import { getAppConfigSetting } from "../utils";
import currency from "currency.js";
import { Row } from "apex-table-ts";

export const ROUTER_BASENAME = "risk-ui";
export const LEGIT_SERVICE_CONFIG = {
  useSessionLogin: false,
  apiUrl: getAppConfigSetting("legitApiUrl"),
};
export const ALL_REQUESTED_PERMISSIONS = ["account.read"];
export const HOST = window.location.host;
export const SCOPES = "openid profile email";
export const RISK_API_HOST = getAppConfigSetting(
  "riskApiUrl",
  "http://localhost"
);
export const RISK_API_ENDPOINT = `${RISK_API_HOST}/api/v1/risk`;
export const RISK_MTM_REPORT_ENDPOINT = `${RISK_API_HOST}/api/v1/reports/mtm`;
export const RISK_CF_REPORT_ENDPOINT = `${RISK_API_HOST}/api/v1/reports/cf`;
export const RISK_VAR_REPORT_ENDPOINT = `${RISK_API_HOST}/api/v1/reports/var`;
export const RISK_PROJECTED_VAR_REPORT_ENDPOINT = `${RISK_API_HOST}/api/v1/reports/projected-var`;

export const RISK_ALERTS_ENDPOINT = `${RISK_API_HOST}/api/v1/risk/alerts`;
export const RISK_INSTRUMENT_ENDPOINT = `${RISK_API_HOST}/api/v1/reports/instrument`;
export const CORRESPONDENT_INSTRUMENT_ENDPOINT = `${RISK_API_HOST}/api/v1/correspondent`;

const FloatSorter = (col: string) => (a: Row, b: Row) => {
  const f1 = parseFloat(a[col] as string);
  const f2 = parseFloat(b[col] as string);
  if (f1 > f2) {
    return 1;
  }
  if (f1 < f2) {
    return -1;
  }
  return 0;
};

export const MTM_COLUMNS = {
  tkr: {
    clickable: false,
    label: "Ticker",
    isVisible: true,
    resizable: true,
    width: 100,
    filter: "text",
    sort: "text",
    sortable: true,
  },
  cusip: {
    clickable: false,
    label: "Cusip",
    isVisible: true,
    resizable: true,
    width: 110,
    sortable: true,
    filter: "text",
  },
  curReq: {
    clicakble: false,
    label: "Requirement",
    isVisible: true,
    resizable: true,
    width: 130,
    disabled: true,
    sortable: true,
    sort: FloatSorter,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  reqChg: {
    clickable: false,
    label: "Req Change",
    isVisible: true,
    resizable: true,
    width: 130,
    sortable: true,
    sort: FloatSorter,
    disabled: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  curAmt: {
    clicakble: false,
    label: "Position",
    isVisible: true,
    resizable: true,
    width: 130,
    sortable: true,
    sort: FloatSorter,
    disabled: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  amtChg: {
    clickable: false,
    label: "Position Change",
    isVisible: true,
    resizable: true,
    width: 130,
    sortable: true,
    sort: FloatSorter,
    disabled: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
};

export const VAR_COLUMNS = {
  Symbol: {
    clickable: false,
    label: "Symbol",
    isVisible: true,
    resizable: true,
    width: 85,
    filter: "text",
    sort: "text",
    sortable: true,
  },
  CUSIP: {
    clickable: false,
    label: "Cusip",
    isVisible: true,
    resizable: true,
    width: 95,
    sortable: true,
    filter: "text",
  },
  CurrentRequirement: {
    clickable: false,
    label: "Requirement",
    isVisible: true,
    resizable: true,
    width: 100,
    disabled: true,
    sort: FloatSorter,
    sortable: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  RequirementChange: {
    clickable: false,
    label: "Req Change",
    isVisible: true,
    resizable: true,
    width: 110,
    disabled: true,
    sort: FloatSorter,
    sortable: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  CurrentQuantity: {
    clickable: false,
    label: "Quantity",
    isVisible: true,
    resizable: true,
    width: 100,
    disabled: true,
    sort: FloatSorter,
    sortable: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  QuantityChange: {
    clickable: false,
    label: "Quantity Change",
    isVisible: false,
    resizable: true,
    width: 110,
    disabled: true,
    sort: FloatSorter,
    sortable: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  CurrentAmount: {
    clicakble: false,
    label: "Position Amount",
    isVisible: true,
    resizable: true,
    width: 110,
    disabled: true,
    sort: FloatSorter,
    sortable: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
  AmountChange: {
    clickable: false,
    label: "Position Change",
    isVisible: true,
    resizable: true,
    width: 115,
    disabled: true,
    sort: FloatSorter,
    sortable: true,
    formatter: (obj: string) => (obj ? currency(obj).format() : "-"),
  },
};

export const CORRESPONDENT_COLUMNS = {
  correspondentCode: {
    clickable: false,
    label: "Correspondent Code",
    isVisible: true,
    resizable: true,
    width: 200,
    filter: "text",
    sort: "text",
    sortable: true,
  },
  side: {
    clickable: false,
    label: "Side",
    isVisible: true,
    resizable: true,
    width: 200,
    sortable: true,
    filter: "text",
  },
  symbol: {
    clicakble: false,
    label: "Symbol",
    isVisible: true,
    resizable: true,
    width: 200,
    disabled: true,
    sortable: true,
  },
  qty: {
    clickable: false,
    label: "Quantity",
    isVisible: true,
    resizable: true,
    width: 200,
    sortable: true,
    sort: FloatSorter,
    disabled: true,
  },
};
export const SOD = "SOD";
